module.exports = __webpack_public_path__ + "static/img/activity_sdy_04-2.312df40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_04-2.jpg
// module id = 1Kdt
// module chunks = 0